module.exports = __webpack_public_path__ + "static/bsas020.thumb-79e76dbc5754bdf6b48a3d08cda33680.jpg";